function componentsCheckout() {
  // add - apply discount coupon button in cart summary
  applyDiscountCoupon();

  // quatro - change text on thank-you page
  quatroChangeTextInOrder();

  // check if mattress is in cart – if yes, add a class to body and display additional service "Stress-Free Mattress Exchange"
  if (shopName === 'wsk' || shopName === 'jam' || shopName === 'dpc') {
    if ($('body').hasClass('in-kosik')) {
      handleMattressInCart();
    }
  }

  if ($('body').hasClass('in-krok-1') || $('body').hasClass('in-lepes-1') || $('body').hasClass('in-comanda-plata-si-transport') || $('body').hasClass('in-step-1')) {
    // calculate weight and change position of tooltiptext - in 1st step of checkout
    calculateWeightToolTip();
    // hide Google Pay on iOS devices & safari browser
    hideGooglePay();
  }

  // age notice for newsletter and registration - in the 2nd step of checkout
  registrationNewsletterAgeNotice();

  // pexeso gift control
  pexesoGiftControl();

  // rename "Vyberte si darček" → "Získavate darček" and product name in cart free-gift selector
  renameFreeGiftLabels();

  if (shopName === 'wsk' || shopName === 'whu') {
    digitalPickup();
  }

  addAddressNoteField();
}

function applyDiscountCoupon() {
  if ($('.cart-summary .extras-wrapper').length) {
    // if exist element applied-coupon no apply function
    if ($('.cart-summary .extras-wrapper .discount-coupon .applied-coupon').length) {
      return;
    }
    var sPosition = Array.prototype.slice.call($('.extras-wrapper .extras-col'));
    var fPosition = sPosition[0],
      nItem = document.createElement('div');
    nItem.className = 'n-item';
    switch (lang) {
      case 'sk':
        nItem.textContent = 'Uplatniť zľavový kupón';
        break;
      case 'hu':
        nItem.textContent = 'Akciós kupon érvényesítése';
        break;
      case 'cs':
        nItem.textContent = 'Uplatnit slevový kupón';
        break;
      case 'ro':
        nItem.textContent = 'Aplicați un cupon de reducere';
        break;
      case 'bg':
        nItem.textContent = 'Uplatniť zľavový kupón';
        break;
      case 'hr':
        nItem.textContent = 'Iskoristiti kupon za popust';
        break;
      case 'sl':
        nItem.textContent = 'Uveljaviti kodo za popust';
        break;
      case 'uk':
        nItem.textContent = 'Uplatniť zľavový kupón';
        break;
      default:
        return;
    }
    fPosition.appendChild(nItem);
    var rollD = $('.extras-col');
    rollD.find('.discount-coupon').hide();
    rollD.find('.n-item').on('click', function () {
      rollD.find('.discount-coupon').show();
      rollD.find('.n-item').hide();
    });
  }
}

function calculateWeightToolTip() {
  var weightPriceLink;
  var shippingId = 'shipping-1';
  switch (shopName) {
    case 'wsk':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    case 'whu':
      weightPriceLink = 'https://www.wilsondo.hu/lakasba-szallitas/';
      break;
    case 'wcz':
      weightPriceLink = 'https://wilsondo.cz/vynos-tovaru/';
      shippingId = 'shipping-113';
      break;
    case 'wro':
      weightPriceLink = 'https://wilsondo.cz/vynos-tovaru/';
      shippingId = 'shipping-113';
      break;
    case 'wbg':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    case 'whr':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    case 'wsi':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    case 'wua':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    case 'dpc':
      weightPriceLink = 'https://www.detskapostel.com/doprava-a-platba/#links-3';
      break;
    case 'mee':
      weightPriceLink = 'https://www.matrac-es-en.hu/szallitas-fizetes/#links-2';
      shippingId = 'shipping-6';
      break;
    case 'jam':
      weightPriceLink = 'https://www.ja-a-matrac.sk/doprava--platba--vynos/#links-3';
      shippingId = 'shipping-6';
      break;
    case 'eag':
      weightPriceLink = 'https://www.emeletes-agyak.hu/szallitas-fizetes-felvitel/#links-2';
      shippingId = 'shipping-6';
      break;
    case 'pos':
      weightPriceLink = 'https://www.poschodovky.sk/doprava-a-platba/#links-3';
      shippingId = 'shipping-6';
      break;
    default:
      return;
  }

  function fToolTipTextMove(pNode) {
    var myToolTip = pNode.find('label span.question-tooltip');
    var myToolTipText = myToolTip.attr('title');
    // calculate weight
    if (pNode.attr('id') === shippingId) {
      var totalWeight = 0;
      if (dataLayer && dataLayer[0] && dataLayer[0].shoptet && dataLayer[0].shoptet.cart) {
        dataLayer[0].shoptet.cart.forEach(function (item) {
          totalWeight = totalWeight + item.quantity * item.weight;
        });
        if (totalWeight > 0) {
          totalWeight = Math.round(totalWeight * 100) / 100;
        }
        switch (lang) {
          case 'sk':
            myToolTipText = myToolTipText + '<div>Celková hmotnosť objednávky: <strong>' + totalWeight + '&nbsp;kg</strong>. <br />Šofér vám BEZPLATNE pomôže vyložiť tovar až k prvým uzamýkateľným dverám. Ak máte záujem aj o výnos, pozrite si prosím <a class="zasilkovna-name" href="' + weightPriceLink + '">podmienky výnosu tovaru</a>.</div>';
            break;
          case 'hu':
            myToolTipText = myToolTipText + '<div>A rendelés összsúlya: <strong>' + totalWeight + '&nbsp;kg</strong>. <br />A sofőrünk egészen az első zárható ajtóig viszi INGYENESEN a megrendelt terméket. Amennyiben lakásba szállítást is igénybe szeretne venni, kérem tekintse meg annak feltételeit <a class="zasilkovna-name" href="' + weightPriceLink + '">ITT</a>.</div>';
            break;
          case 'cs':
            myToolTipText = myToolTipText + '<div>Celková hmotnost objednávky: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
            break;
          case 'ro':
            myToolTipText = myToolTipText + '<div>Greutatea totală a comenzii: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
            break;
          case 'bg':
            myToolTipText = myToolTipText + '<div>Celková hmotnosť objednávky: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
            break;
          case 'hr':
            myToolTipText = myToolTipText + '<div>Ukupna težina narudžbe: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
            break;
          case 'sl':
            myToolTipText = myToolTipText + '<div>Skupna teža naročila: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
            break;
          case 'uk':
            myToolTipText = myToolTipText + '<div>Celková hmotnosť objednávky: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
            break;
          default:
            return;
        }
      }
    }
    // change position tooltiptext
    $('<div class="tooltiptext">' + myToolTipText + '</div>').insertAfter($(myToolTip).closest('label'));
  }

  $('div#order-shipping-methods>div').each(function () {
    fToolTipTextMove($(this));
  });
  $('div#order-billing-methods>div').each(function () {
    fToolTipTextMove($(this));
  });
}

function registrationNewsletterAgeNotice() {
  var url = document.location.href;
  var confirmation;
  switch (lang) {
    case 'sk':
      confirmation = {
        urlCheckout: '/objednavka/krok-2/',
        //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettre sú určené pre osoby staršie ako 16 rokov!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> Registrácia je určená pre osoby staršie ako 16 rokov!</span>',
      }
      break;
    case 'hu':
      confirmation = {
        urlCheckout: '/rendeles/lepes-2/',
        //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Hírlevelek a 16 év feletti emberek számára!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> A regisztráció 16 év feletti emberek számára!</span>',
      }
      break;
    case 'cs':
      confirmation = {
        urlCheckout: '/objednavka/krok-2/',
        //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettery jsou určeny pro osoby starší než 16 let!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> Registrace je určena pro osoby starší než 16 let!</span>',
      }
      break;
    case 'ro':
      confirmation = {
        urlCheckout: '/comanda/comanda-informatii-despre-dvs/',
        //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Buletinele informative sunt destinate persoanelor peste 16 ani!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> Înregistrarea este destinată persoanelor peste 16 ani!</span>',
      }
      break;
    case 'bg':
      confirmation = {
        urlCheckout: '/order/step-2/',
        //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettre sú určené pre osoby staršie ako 16 rokov!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> Registrácia je určená pre osoby staršie ako 16 rokov!</span>',
      }
      break;
    case 'hr':
      confirmation = {
        urlCheckout: '/order/step-2/',
        //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettri su namijenjene osobama starijim od 16 godina!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> Registracija je namijenjena osobama starijim od 16 godina!</span>',
      }
      break;
    case 'sl':
      confirmation = {
        urlCheckout: '/order/step-2/',
        //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;E-novice so namenjene osebam, starejšim od 16 let!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> Registracija je namenjena osebam, starejšim od 16 let!</span>',
      }
      break;
    case 'uk':
      confirmation = {
        urlCheckout: '/order/step-2/',
        //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettre sú určené pre osoby staršie ako 16 rokov!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> Registrácia je určená pre osoby staršie ako 16 rokov!</span>',
      }
      break;
    default:
      return;
  }
  if (url.indexOf(confirmation.urlCheckout) > -1) {
    //  $('.ordering-process .co-box.co-box-additional .stay-in-touch div.form-group label[for="sendNewsletter"]').append(confirmation.newsletterAgeNotice);
    $('.ordering-process .co-box.co-box-additional .stay-in-touch div.form-group label[for="set-registration"]').append(confirmation.registerAgeNotice);
  }
}

function hideGooglePay() {
  if (window.ApplePaySession && $('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').length) {
    $('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').parent('.payment-info').parent('.billing-name').parent().hide();
  } else if ($('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').length) {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      $('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').parent('.payment-info').parent('.billing-name').parent().hide();
    } else if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      $('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').parent('.payment-info').parent('.billing-name').parent().hide();
    }
  }
}

function handleMattressInCart() {
  const cartItemsCheck = getShoptetDataLayer('cart');
  if ($.isArray(cartItemsCheck) && cartItemsCheck.some(item => item.name && item.name.toLowerCase().includes("matrac"))) {
    $(document.body).addClass('mattress-in-cart');
  } else {
    $(document.body).removeClass('mattress-in-cart');
  }
}

function quatroChangeTextInOrder() {
  const recapPaymentMethod = $('.in-dakujeme .recapitulation-table td[data-testid="recapPaymentMethod"]');
  // Check if it contains the text 'Quatro Splátky'
  if (recapPaymentMethod.text().trim() === 'Quatro Splátky') {
    // Change text of title
    $('.order-summary-heading').text('Vaša objednávka čaká na vyplnenie žiadosti o splátku');
    // Change text of payment description
    $('.reca-payment-wrap p[data-testid="textAbovePayButton"]').text('Kliknite na tlačidlo nižšie a vyplňte žiadosť o splátku');
    // Change text of payment button
    $('#onlinePaymentButton').text('Kliknite a vyplňte žiadosť');
  }
}

function pexesoGiftControl() {
  setTimeout(() => {
    var headline;

    switch (lang) {
      case 'sk':
        headline = 'V košíku máte produkt, ku ktorému môžete získať darček.';
        break;
      case 'hu':
        headline = 'A kosarában egy olyan termék van, amelyhez ajándékot is kaphat.';
        break;
      case 'cs':
        headline = 'V košíku máte produkt, ke kterému můžete získat dárek.';
        break;
      case 'ro':
        headline = "In coș aveți un produs lăngă care puteți primi un cadou";
        break;
      case 'hr':
        headline = "U košarici imate proizvod za koji možete dobiti poklon.";
        break;
      case 'sl':
        headline = 'V košarici imate izdelek, ob katerem lahko prejmete darilo.';
        break;
      default:
        return;
    }

    var targetContent = document.querySelector('.fvDoplnek-category .fvcontent[code="10000017565"]');
    if (!targetContent) return;

    var targetCategory = targetContent.closest('.fvDoplnek-category');
    if (!targetCategory) return;

    var hasDiscountInCart = !!document.querySelector('.cart-xyDiscount__banner');

    // texty
    var headlineEl = targetCategory.querySelector('h5');
    if (headlineEl) {
      headlineEl.textContent = headline;
    }

    // cta 
    var nameEl = targetContent.querySelector('.fvDoplnek-text .name');
    var checkbox = targetContent.querySelector('.fvDoplnek-variant-checkbox');

    if (nameEl && checkbox && !nameEl.dataset.boundClick) {
      nameEl.style.cursor = 'pointer';
      nameEl.addEventListener('click', function () {
        checkbox.click(); // toggle checkbox
      });
      nameEl.dataset.boundClick = 'true'; // aby sme neviazali listener viackrát
    }

    if (hasDiscountInCart) {
      targetCategory.style.display = 'flex';
    } else {
      targetCategory.style.display = 'none';
    }
  }, 300);
}

function renameFreeGiftLabels() {
  setTimeout(function () {
    var label, name;

    switch (lang) {
      case 'sk':
        label = 'Získavate darček';
        break;
      case 'hr':
        label = 'Kupnjom dobivate poklon';
        break;
      case 'sl':
        label = 'Pridobite darilo';
        break;
      case 'ro':
        label = 'Obține un cadou';
        break;
      case 'cs':
        label = 'Získáváte dárek';
        break;
      case 'hu':
        label = 'Ajándékot is kap tőlünk';
        break;
      default:
        return;
    }

    var firstGift = document.querySelector('.cart-summary .your-gift');
    if (firstGift && label) {
      firstGift.textContent = label;
    }
  }, 300);
}

function digitalPickup() {
  var title, description;

  switch (shopName) {
    case 'wsk':
      title = 'Zaslanie e-mailom';
      description = 'Po úspešnej úhrade objednávky vám elektronický poukaz zašleme obratom na e-mail, vhodný na tlač aj okamžité darovanie.';
      break;
    case 'whu':
      title = 'Elküldés e-mailben';
      description = 'A sikeres fizetés után az elektronikus ajándékutalványt e-mailben küldjük el Önnek. Innen egyszerűen kinyomtatjatja, és már ajándékozásra kész.';
      break;
    default:
      return;
  }

  const root = document.querySelector('.ordering-process');
  if (!root) return;

  const skuItems = Array.from(root.querySelectorAll('[data-micro-sku]'));
  let allAreVouchers = false;

  if (skuItems.length) {
    allAreVouchers = skuItems.every(el => {
      const sku = (el.getAttribute('data-micro-sku') || '').trim();
      return /^ADPOUKAZ/i.test(sku);
    });
  } else {
    const voucherNameRe = (shopName === 'whu')
      ? /^Elektronikus ajándékutalvány$/i
      : /^Elektronický darčekový poukaz$/i;

    const nameEls = Array.from(root.querySelectorAll('span[data-testid="recapItemName"]'));
    if (!nameEls.length) return;

    allAreVouchers = nameEls.every(el =>
      voucherNameRe.test((el.textContent || '').replace(/\s+/g, ' ').trim())
    );
  }

  if (!allAreVouchers) return;

  const from = (shopName === 'whu') ? 'Futárszolgálattal' : 'Osobný odber';

  // názov metódy + tooltip
  $('.ordering-process .shipping-billing-name').each(function () {
    if ($(this).text().replace(/\s+/g, ' ').trim() !== from) return;

    $(this).text(title);

    const $method = $(this).closest('.radio-wrapper[data-testid="shippingMethod"], .radio-wrapper');
    const $tooltip = $method.find('.tooltiptext').first();
    if ($tooltip.length) $tooltip.html(description);
  });

  // recap v checkoute (neprepisujeme cenu)
  $('.ordering-process strong[data-testid="recapDeliveryMethod"]').each(function () {
    $(this).contents().filter(function () {
      return this.nodeType === 3;
    }).each(function () {
      const t = (this.nodeValue || '').replace(/\s+/g, ' ').trim();
      if (t === from) this.nodeValue = ' ' + title;
    });
  });

  // thank-you page
  $('.ordering-process td[data-testid="recapDeliveryMethod"] strong').each(function () {
    if ($(this).text().replace(/\s+/g, ' ').trim() === from) $(this).text(title);
  });
}

function addAddressNoteField() {
  var labelText, buttonText;

  switch (lang) {
    case 'sk': labelText = "Upresnenie adresy"; buttonText = "Pridať upresnenie adresy"; break;
    case 'hu': labelText = "A cím pontosítása"; buttonText = "Címadatok hozzáadása"; break;
    case 'cs': labelText = "Upřesnění adresy"; buttonText = "Přidat upřesnění adresy"; break;
    case 'ro': labelText = "Clarificarea adresei"; buttonText = "Adăugați detalii despre adresă"; break;
    case 'bg': labelText = "Уточняване na adresy"; buttonText = "Добавяне na данни za adresy"; break;
    case 'hr': labelText = "Pojašnjenje adrese"; buttonText = "Dodajte podatke o adresi"; break;
    case 'sl': labelText = "Pojasnilo naslova"; buttonText = "Dodajte podrobnosti naslova"; break;
    case 'ua': labelText = "Уточнення adresy"; buttonText = "Додати дані adresy"; break;
    default: return;
  }

  var $deliveryHouseNumber = $('#deliveryHouseNumber');
  var $billingCity = $('#billCity');
  if (!$deliveryHouseNumber.length || !$billingCity.length) return;

  // custom input
  var $deliveryInput = $('#deliveryAddressNote');
  if (!$deliveryInput.length) {
    $deliveryHouseNumber.after(
      '<div class="form-group js-validated-element-wrapper smart-label-wrapper js-address-note-group">' +
      '<label for="deliveryAddressNote">' + labelText + '</label>' +
      '<input type="text" value="" id="deliveryAddressNote" class="form-control" />' +
      '</div>'
    );
    $deliveryInput = $('#deliveryAddressNote');
  }

  // klon custom inputu pre doručovaciu adresu
  var $billingInput = $('#billAddressNote');
  if (!$billingInput.length) {
    var $clone = $deliveryInput.closest('.js-address-note-group').clone(true, true);
    $clone.find('label').attr('for', 'billAddressNote').text(labelText);
    $clone.find('input').attr('id', 'billAddressNote').val($deliveryInput.val());
    $billingCity.after($clone);
    $billingInput = $('#billAddressNote');
  }

  var $deliveryGroup = $deliveryInput.closest('.js-address-note-group');
  var $billingGroup = $billingInput.closest('.js-address-note-group');
  if (!$deliveryGroup.length || !$billingGroup.length) return;

  $deliveryGroup.find('label').text(labelText);
  $billingGroup.find('label').text(labelText);

  if (!$deliveryGroup.data('addressNoteInit')) $deliveryGroup.hide().data('addressNoteInit', true);
  if (!$billingGroup.data('addressNoteInit')) $billingGroup.hide().data('addressNoteInit', true);

  // toggle button
  var $deliveryButton = $deliveryHouseNumber.closest('.form-group').find('.js-address-note-toggle');
  if (!$deliveryButton.length) {
    $deliveryHouseNumber.after(
      '<button type="button" class="btn text js-address-note-toggle add-address-info" style="margin: 8px 0;">' +
      buttonText +
      '</button>'
    );
    $deliveryButton = $deliveryHouseNumber.closest('.form-group').find('.js-address-note-toggle');
  } else {
    $deliveryButton.text(buttonText);
  }

  var $billingButton = $billingCity.closest('.form-group').find('.js-address-note-toggle');
  if (!$billingButton.length) {
    $billingCity.after(
      '<button type="button" class="btn text js-address-note-toggle" style="margin: 8px 0;">' +
      buttonText +
      '</button>'
    );
    $billingButton = $billingCity.closest('.form-group').find('.js-address-note-toggle');
  } else {
    $billingButton.text(buttonText);
  }

  function setVisibleBoth(visible) {
    visible ? ($deliveryGroup.show(), $billingGroup.show()) : ($deliveryGroup.hide(), $billingGroup.hide());
    $deliveryGroup.attr('aria-hidden', visible ? 'false' : 'true');
    $billingGroup.attr('aria-hidden', visible ? 'false' : 'true');
  }

  $deliveryButton.off('click.addressNote').on('click.addressNote', function () {
    setVisibleBoth(!$deliveryGroup.is(':visible'));
  });
  $billingButton.off('click.addressNote').on('click.addressNote', function () {
    setVisibleBoth(!$deliveryGroup.is(':visible'));
  });

  // sync hodnoty
  $deliveryInput.off('input.addressNote').on('input.addressNote', function () {
    $billingInput.val($deliveryInput.val());
  });
  $billingInput.off('input.addressNote').on('input.addressNote', function () {
    $deliveryInput.val($billingInput.val());
  });

  // injectneme hodnotu do textarea pri odoslaní objednávky
  var $remark = $('#remark');
  var $addNote = $('#add-note');
  var $note = $('#note');

  function escRe(s) { return (s || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function buildRemark(original, addressValue) {
    var v = (addressValue || '').trim();
    if (!v) return original || '';

    var prefix = labelText + ': ';
    var reLine = new RegExp('^' + escRe(prefix) + '.*\\n?', 'm');
    var base = (original || '').replace(reLine, '').trim();

    return (base ? base + '\n' : '') + prefix + v;
  }

  function injectNow() {
    if (!$remark.length) return;

    var v = ($deliveryInput.val() || '').trim();
    if (!v) return;

    if ($addNote.length && !$addNote.prop('checked')) $addNote.prop('checked', true).trigger('change');
    if ($note.length) $note.addClass('visible');

    $remark.val(buildRemark($remark.val(), v)).trigger('change');
  }

  var $form = $('#submit-order').closest('form');
  if ($form.length) {
    $form.off('submit.addrNote').on('submit.addrNote', function () {
      injectNow();
    });
  }
}


// NOVÝ KOŠÍK 
function moveCoupon() {
  const root = document.querySelector('.ordering-process');
  if (!root) return;

  const target = root.querySelector('.sidebar-in-cart');
  const discount = root.querySelector('.discount-coupon');
  const items = root.querySelectorAll('.n-item');

  if (!target || (!discount && items.length === 0)) return;

  let wrapper = root.querySelector('.discount-coupon-wrapper');
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.className = 'discount-coupon-wrapper';
  }

  if (discount && discount.parentElement !== wrapper) wrapper.append(discount);
  items.forEach(el => { if (el.parentElement !== wrapper) wrapper.append(el); });

  target.append(wrapper);

  wrapper.addEventListener('click', (e) => {
    const item = e.target.closest('.n-item');
    if (!item) return;
    if (discount) discount.style.display = 'block';
    item.style.display = 'none';
  });
}

function totalSaveMessage() {
  var totalDiscountTerm, stepInCheckout;
  switch (lang) {
    case 'sk':
      totalDiscountTerm = 'Ušetríte celkom';
      break;
    case 'hu':
      stepInCheckout = '.in-kosar';
      totalDiscountTerm = 'Megtakarítás:';
      break;
    case 'cs':
      totalDiscountTerm = 'Ušetříte celkem';
      break;
    case 'ro':
      stepInCheckout = '.in-cos-de-cumparaturi';
      totalDiscountTerm = 'În total ai economisit';
      break;
    case 'hr':
      stepInCheckout = '.in-cart';
      totalDiscountTerm = 'Uštedjet ćete ukupno';
      break;
    case 'sl':
      stepInCheckout = '.in-cart';
      totalDiscountTerm = 'Prihranite skupaj';
      break;
    default:
      totalDiscountTerm = 'Total saved';
      break;
  }

  // posledný shoptet objekt v dataLayer
  if (!Array.isArray(window.dataLayer)) return;
  let dlShoptet = null;
  for (let i = window.dataLayer.length - 1; i >= 0; i--) {
    if (window.dataLayer[i] && window.dataLayer[i].shoptet) {
      dlShoptet = window.dataLayer[i].shoptet;
      break;
    }
  }
  if (!dlShoptet || !dlShoptet.cartInfo) return;

  // zdroje dát
  const items = Array.isArray(dlShoptet.cartInfo.cartItems)
    ? dlShoptet.cartInfo.cartItems
    : (Array.isArray(dlShoptet.cart) ? dlShoptet.cart : []);
  const finalWithVat = Number(dlShoptet.cartInfo.getNoBillingShippingPrice?.withVat || 0);
  const cinfo = dlShoptet.currencyInfo || {};

  // suma bez zliav
  let sumWithoutDiscount = 0;
  items.forEach(it => {
    sumWithoutDiscount += Number(it.priceWithoutDiscount || 0) * Number(it.quantity || 0);
  });

  // celková zľava
  let discount = sumWithoutDiscount - finalWithVat;

  const $target = $('.cart-content.summary-wrapper');
  if (!$target.length) return;

  $target.find('.total-discount').remove();
  if (!(discount > 0)) return;

  const places = Number(cinfo.priceDecimalPlaces ?? 2);
  const dec = cinfo.decimalSeparator || ',';
  const thou = cinfo.thousandSeparator || ' ';
  const sym = cinfo.symbol || '€';
  const symbolLeft = !!cinfo.symbolLeft;

  const fixed = discount.toFixed(places);
  let [intPart, fracPart = ''] = fixed.split('.');
  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
  const numStr = places > 0 ? intPart + dec + fracPart : intPart;
  const formatted = symbolLeft ? (sym + (cinfo.symbolLeft ? ' ' : '') + numStr)
    : (numStr + (cinfo.symbolLeft ? '' : ' ') + sym);

  const $banner = $(`
    <div class="total-discount">
      <span>${totalDiscountTerm} ${formatted}</span>
    </div>
  `);

  $target.prepend($banner);
}

function addRelatedProductsToCart() {
  var relatedProductsTitleTerm;
  switch (lang) {
    case 'sk':
      relatedProductsTitleTerm = 'Ostatní zákazníci tiež zakúpili';
      break;
    case 'hu':
      relatedProductsTitleTerm = 'A többi vevő ezeket vásárolta még';
      break;
    case 'cs':
      relatedProductsTitleTerm = 'Ostatní zákazníci také nakoupili';
      break;
    case 'ro':
      relatedProductsTitleTerm = 'Alţi clienţi au cumpărat şi';
      break;
    case 'hr':
      relatedProductsTitleTerm = 'Drugi kupci su također kupili';
      break;
    case 'sl':
      relatedProductsTitleTerm = 'Drugi kupci so poleg tega kupili tudi';
      break;
  }

  var uniqueNames = [];
  // Prejde všetky elementy .cart-related-product v rámci .cart-table
  $('.cart-table div.cart-related-product').each(function () {
    // Nájde text v elemente .cart-related-info .cart-related-name
    var nameText = $(this).find('.cart-related-info .cart-related-name').text().trim();

    // Skontroluje, či sa tento text už nachádza v poli uniqueNames
    if (!uniqueNames.includes(nameText)) {
      // Ak nie, pridá text do poľa uniqueNames
      uniqueNames.push(nameText);
      // Vypíše element .cart-related-product, ak je unikátny
      $('#cart-wrapper').append($(this).clone().addClass('new-cart-related-item').removeClass('cart-related-product'));
    }
  });

  $('.new-cart-related-item').wrapAll('<div class="new-cart-related-wrap"></div>');
  $('.ordering-process .new-cart-related-wrap').addClass('carousel__specific_style');
  $('.ordering-process .new-cart-related-item').addClass('carousel__slide');

  document.querySelectorAll(".carousel__specific_style").forEach((el) => {
    new Carousel(el, {
      Dots: false,
      Navigation: true,
      infinite: true,
      fill: true,
      Autoplay: false,
      center: false,
      slidesPerPage: 2,
      transition: "slide",
      transitionDuration: 350,

      breakpoints: {
        "(max-width: 767px)": {
          Navigation: false
        },
        "(min-width: 768px)": {
          slidesPerPage: 4
        }
      }
    });
  });

  $('.carousel__specific_style').each(function () {
    var productsCount = $(this).find('.new-cart-related-item').length;
    if (productsCount <= 2) {
      $(this).addClass('carousel-related-products');
    }
  });

  // Nájde všetky obrázky v elementoch s triedou `.cart-related-img img`
  const images = document.querySelectorAll('.cart-related-info .cart-related-img img');

  images.forEach(img => {
    // Ak má obrázok atribút data-src a obsahuje 'related', prepíš 'related' na 'detail'
    if (img.hasAttribute('data-src') && img.getAttribute('data-src').includes('/related/')) {
      img.setAttribute('data-src', img.getAttribute('data-src').replace('/related/', '/detail/'));
    }
    // Nastav src na hodnotu z data-src, ak existuje data-src kvôli lazy_loadingu
    if (img.hasAttribute('data-src')) {
      img.src = img.getAttribute('data-src');
    }
  });

  // wrapper
  const $wrap = $('.ordering-process .new-cart-related-wrap');
  $wrap.wrap('<div class="related-products-wrapper"></div>');

  // Nadpis do wrapperu
  var titleCartCustome = '<h2 class="cart-related-products-title">' + relatedProductsTitleTerm + '</h2>';
  $wrap.before(titleCartCustome);

  $('.new-cart-related-wrap')
    .addClass('carousel__specific_style carousel-related-products container');

  const $outer = $wrap.parent(); // .related-products-wrapper
  $outer.appendTo($('.ordering-process .overall-wrapper').last());
}

function checkoutButtonContinue() {
  var $scope = $('.id--9');
  if (!$scope.length) return;

  var $btn = $scope.find('#continue-order-button');
  var $target = $scope.find('.related-products-wrapper');

  if (!$btn.length || !$target.length) return;

  if ($scope.find('#continue-order-button-clone').length) return;

  var $clone = $btn.clone(true, true)
    .attr('id', 'continue-order-button-clone');

  var $wrapper = $('<div class="continue-order-button-wrapper"></div>').append($clone);

  $target.after($wrapper);
}

function addCheckoutBenefits() {
  var freeShippingAmount = window.freeShippingAmount;
  if (!freeShippingAmount) return;

  var $scope = $('.id--9');
  if (!$scope.length) return;

  var $wrap = $scope.find('.related-products-wrapper');
  if (!$wrap.length) return;

  // ochrana proti duplicitám
  if ($scope.find('.checkout-benefits').length) return;

  var benefitsByShop = {
    wsk: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.sk/user/banners/truck.png',
        title: 'Expresné doručenie',
        desc: 'Matrace skladom odošleme do 24 hodín'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.sk/user/banners/inventory.png',
        title: 'Produkty skladom',
        desc: '90 % produktov skladom'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.sk/user/banners/check.png',
        title: 'Doprava zadarmo',
        desc: 'Pri nákupe nad ' + freeShippingAmount
      }
    ],
    whu: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.hu/user/banners/truck.png',
        title: 'Matracok expressz kiszállítása',
        desc: 'Az árukészletet 24 órán belül szállítjuk'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.hu/user/banners/inventory.png',
        title: 'Raktáron lévő termékek',
        desc: 'Termékeink 90 %-a raktáron van'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.hu/user/banners/check.png',
        title: 'Ingyenes szállítás',
        desc: freeShippingAmount + ' felett'
      }
    ],
    wcz: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/banners/truck-1.png',
        title: 'Expresní doručení',
        desc: 'Odesíláme do 24h'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/banners/inventory.png',
        title: 'Produkty skladem',
        desc: '90 % kousků skladem'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/banners/check.png',
        title: 'Doprava zdarma',
        desc: 'Nad ' + freeShippingAmount
      }
    ],
    wro: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.ro/user/banners/truck.png',
        title: 'Livrare expres',
        desc: 'Pentru saltelele aflate pe stoc, coletul este preluat de către curier in cel mult 24 de ore'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.ro/user/banners/inventory.png',
        title: 'Produse în stoc',
        desc: '90 % din produse în stoc'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.ro/user/banners/check.png',
        title: 'Livrare gratuită',
        desc: 'la comenzi de peste ' + freeShippingAmount
      }
    ],
    whr: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.hr/user/banners/truck.png',
        title: 'Ekspresna dostava',
        desc: 'Madrace na skladištu šaljemo u roku od 24 sata'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.hr/user/banners/inventory.png',
        title: 'Proizvodi na skladištu',
        desc: '90 % proizvoda na skladištu'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.hr/user/banners/check.png',
        title: 'Besplatna dostava',
        desc: 'Besplatna dostava od ' + freeShippingAmount
      }
    ],
    wsi: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.si/user/banners/truck.png',
        title: 'Ekspresna dostava',
        desc: 'Vzmetnice, ki so na zalogi, pošljemo v 24 urah'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.si/user/banners/inventory.png',
        title: 'Izdelki na zalogi',
        desc: '90 % izdelkov na zalogi'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.wilsondo.si/user/banners/check.png',
        title: 'Brezplačna dostava',
        desc: 'Brezplačna dostava od ' + freeShippingAmount
      }
    ],
    dpc: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.detskapostel.com/user/banners/truck.png',
        title: 'Expresné dodanie',
        desc: 'koberce a matrace do 48 hodín'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.detskapostel.com/user/banners/inventory.png',
        title: 'Široká ponuka',
        desc: 'detského nábytku a matracov skladom'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.detskapostel.com/user/banners/check.png',
        title: 'Doprava zadarmo',
        desc: 'na celý sortiment už nad ' + freeShippingAmount
      }
    ],
    mee: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.matrac-es-en.hu/user/banners/truck-green_hu.png',
        title: 'Matracok expressz kiszállítása',
        desc: '48 órán belül önnél'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.matrac-es-en.hu/user/banners/inventory-green_hu.png',
        title: 'Matracok széles választéka',
        desc: 'raktáron'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.matrac-es-en.hu/user/banners/mark-green_hu.png',
        title: 'Vásárlás ' + freeShippingAmount + ' felett',
        desc: '= ingyenes szállítás'
      }
    ],
    jam: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.ja-a-matrac.sk/user/banners/truck-green.png',
        title: 'Expresné doručenie matracov',
        desc: 'u vás do 48 hodín'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.ja-a-matrac.sk/user/banners/inventory-green.png',
        title: 'Široká ponuka matracov',
        desc: 'skladom'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.ja-a-matrac.sk/user/banners/mark-green.png',
        title: 'Nákup nad ' + freeShippingAmount,
        desc: 's dopravou zadarmo!'
      }
    ],
    eag: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.emeletes-agyak.hu/user/banners/raktaron-levo-termekek_hu.png',
        title: 'Raktáron lévő termékek',
        desc: 'Termékeink 90 %-a raktáron van'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.emeletes-agyak.hu/user/banners/expressz-szallitas_hu.png',
        title: 'Expressz szállítás',
        desc: '48 órán belül'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.emeletes-agyak.hu/user/banners/ingyenes-szallitas_hu.png',
        title: 'Ingyenes szállítás',
        desc: freeShippingAmount + ' felett'
      }
    ],
    pos: [
      {
        img: 'https://cdn.myshoptet.com/usr/www.poschodovky.sk/user/banners/inventory.png',
        title: 'Produkty skladom',
        desc: '90 % produktov skladom'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.poschodovky.sk/user/banners/truck.png',
        title: 'Expresné doručenie',
        desc: 'matrace do 48 hodín'
      },
      {
        img: 'https://cdn.myshoptet.com/usr/www.poschodovky.sk/user/banners/mark.png',
        title: 'Doprava zadarmo',
        desc: 'už od ' + freeShippingAmount
      }
    ],
  };

  var list = benefitsByShop[shopName];
  if (!list || !list.length) return;

  var $box = $('<div class="checkout-benefits"></div>');

  $.each(list, function (_, b) {
    var $item = $(`
      <div class="checkout-benefit">
        <div class="checkout-benefit__img">
          <img src="${b.img}" alt="">
        </div>
        <div class="checkout-benefit__text">
          <div class="checkout-benefit__title">${b.title}</div>
          <div class="checkout-benefit__desc">${b.desc}</div>
        </div>
      </div>
    `);

    $box.append($item);
  });

  // ako posledné vo wrapperi
  $wrap.append($box);
}

function repositionContact() {
  const span = document.querySelector('span.tel[data-testid="contactboxPhone"]');
  const header = document.querySelector('.header-top');
  if (!span || !header) return;

  // vymažeme všetky kvôli ajaxu
  header.querySelectorAll('.nav-contact').forEach(el => el.remove());

  // jeden nový
  const wrap = document.createElement('div');
  wrap.className = 'nav-contact';
  wrap.appendChild(span);

  header.appendChild(wrap);
}

function productDiscountPrice() {
  // vytiahneme objekt z dataLayer
  var dataLayerArray = window.dataLayer || [];
  var shoptetData = null;

  for (var i = dataLayerArray.length - 1; i >= 0; i--) {
    if (dataLayerArray[i] && dataLayerArray[i].shoptet) {
      shoptetData = dataLayerArray[i].shoptet;
      break;
    }
  }
  if (!shoptetData || !shoptetData.cartInfo || !Array.isArray(shoptetData.cartInfo.cartItems)) return;

  // mena a formát z dataLayer.currencyInfo
  var currencyInfo = shoptetData.currencyInfo || {};
  var decimalSeparator = (currencyInfo.decimalSeparator != null) ? currencyInfo.decimalSeparator : ",";
  var thousandSeparator = (currencyInfo.thousandSeparator != null) ? currencyInfo.thousandSeparator : " ";
  var priceDecimalPlaces = (typeof currencyInfo.priceDecimalPlaces === "number") ? currencyInfo.priceDecimalPlaces : 2;
  var currencySymbol = currencyInfo.symbol || "€";
  var currencySymbolLeft = (currencyInfo.symbolLeft === 1 || currencyInfo.symbolLeft === true);
  var exchangeRate = (typeof currencyInfo.exchangeRate === "number") ? currencyInfo.exchangeRate : 1;

  // DOM .p-total a .price-final
  var totalCells = document.querySelectorAll('.p-total');
  if (!totalCells.length) return;

  function roundToDecimals(numberValue) {
    var multiplier = Math.pow(10, priceDecimalPlaces);
    return Math.round((Number(numberValue) + Number.EPSILON) * multiplier) / multiplier;
  }

  function formatPrice(rawValue) {
    if (rawValue == null || isNaN(rawValue)) return null;

    var converted = roundToDecimals(Number(rawValue) * exchangeRate);
    var fixed = converted.toFixed(priceDecimalPlaces);
    var parts = fixed.split('.');
    var integerPart = parts[0];
    var decimalPart = parts[1] || "";

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

    var numberText = (priceDecimalPlaces > 0)
      ? (integerPart + decimalSeparator + decimalPart)
      : integerPart;

    return currencySymbolLeft
      ? (currencySymbol + " " + numberText)
      : (numberText + " " + currencySymbol);
  }

  // vložíme discount cenu do .price-final
  for (var index = 0; index < totalCells.length; index++) {
    var item = shoptetData.cartInfo.cartItems[index];
    if (!item) continue;

    var priceWithoutDiscount = item.priceWithoutDiscount;
    var priceWithVat = item.priceWithVat;
    var quantity = (typeof item.quantity === "number" && item.quantity > 0) ? item.quantity : 1;

    if (priceWithoutDiscount == null || priceWithVat == null) continue;

    // zľava podľa dát
    var discounts = item.discounts || {};
    var finalRatio = (typeof discounts.finalRatio === "number") ? discounts.finalRatio : null;
    var couponRatio = (typeof discounts.couponRatio === "number") ? discounts.couponRatio : null;

    var hasRatioDiscount = false;
    if (finalRatio != null && finalRatio > 0 && finalRatio < 1) hasRatioDiscount = true;
    else if (couponRatio != null && couponRatio > 0 && couponRatio < 1) hasRatioDiscount = true;

    // štandardná zľava bez kupónu
    var hasDirectDiscount = (roundToDecimals(priceWithoutDiscount) !== roundToDecimals(priceWithVat));

    // ak je darček - 100% zľava
    var hasHundredPercentDiscount = false;
    var rowEl = totalCells[index].closest('tr');
    if (rowEl) {
      var discountEl = rowEl.querySelector('.p-discount .show-tooltip, .p-discount');
      var discountText = discountEl ? discountEl.textContent : "";
      if (discountText && discountText.replace(/\s+/g, ' ').indexOf('100 %') !== -1) {
        hasHundredPercentDiscount = true;
      }
    }

    // ak nie je zľava - odstránime span a skonči
    if (!hasDirectDiscount && !hasRatioDiscount && !hasHundredPercentDiscount) {
      var oldDiscountSpan = totalCells[index].querySelector('.price-final .discount-price');
      if (oldDiscountSpan) oldDiscountSpan.remove();
      continue;
    }

    // base cena za kus
    // - pri štandardnej zľave: priceWithoutDiscount
    // - pri kupóne / darčeku: priceWithVat (originál)
    var baseOriginalUnitPrice = hasDirectDiscount ? priceWithoutDiscount : priceWithVat;

    // prepočet na riadkovú cenu (kus * množstvo)
    var originalPriceToShow = roundToDecimals(Number(baseOriginalUnitPrice) * quantity);

    var formattedDiscountPrice = formatPrice(originalPriceToShow);
    if (!formattedDiscountPrice) continue;

    var priceFinalElement = totalCells[index].querySelector('.price-final');
    if (!priceFinalElement) continue;

    var discountSpan = priceFinalElement.querySelector('.discount-price');

    if (discountSpan) {
      discountSpan.textContent = formattedDiscountPrice;
    } else {
      discountSpan = document.createElement('span');
      discountSpan.className = 'discount-price';
      discountSpan.textContent = formattedDiscountPrice;

      // vložíme ako prvý element v .price-final
      priceFinalElement.insertBefore(discountSpan, priceFinalElement.firstChild);
    }
  }
}

function stickyCartSummary() {
  var $summary = $('.summary-wrapper');
  if (!$summary.length) return;

  if ($summary.data('sticky-io')) return;
  $summary.data('sticky-io', true);

  // marker pred originálom
  var marker = document.createElement('div');
  marker.className = 'summary-marker';
  $summary[0].parentNode.insertBefore(marker, $summary[0]);

  var io = new IntersectionObserver(function (entries) {
    var entry = entries[0];

    // ak sme už za originálom
    if (entry.boundingClientRect.top < 0) {
      $summary.removeClass('is-fixed');
      return;
    }
    // ak sme nad originálom
    $summary.toggleClass('is-fixed', !entry.isIntersecting);
  }, {
    threshold: 0,
    rootMargin: '0px 0px -40px 0px'
  });

  io.observe(marker);
}

function emptyCart() {
  var $scope = $('.cart-empty');
  if (!$scope.length) return;

  var $heading = $scope.find('.cart-heading');
  if (!$heading.length) return;

  var $img = $('<img src="https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/wilsondo-prazdny-kosik.svg" alt="Wilsondo" width="417px" height="324px" />');
  $heading.after($img);
}

